// Buffers the most recent console.error() messages so bug reports submitted from the
// field carry the errors that preceded them. Patched once from the app layout.

const MAX_ERRORS = 10;
let buffer: string[] = [];
let patched = false;

// Redact obvious secrets before they're ever attached to a submission.
const sanitize = (message: string): string =>
	message
		.replace(/eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g, '[redacted-token]')
		.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[redacted-email]');

export const initConsoleBuffer = () => {
	if (patched) return;
	patched = true;
	const original = console.error;
	console.error = (...args: unknown[]) => {
		try {
			const message = sanitize(args.map((a) => (typeof a === 'string' ? a : JSON.stringify(a))).join(' '));
			buffer = [...buffer.slice(-(MAX_ERRORS - 1)), message];
		} catch {
			// Never let logging break the patched console.
		}
		original(...args);
	};
};

export const getConsoleErrors = (): string[] => buffer;
